import { h } from 'preact'
import Dropdown from '../dropdown/index'
import Icon from '../assets/'

type HTML_WIDGET = 'html_widget'
type BADGES_WIDGET = 'badges'
type TAG_CLOUD = 'tag_cloud'
type SOLVED_TOPICS_WIDGET = 'solved_topics'
type MOST_LIKED_WIDGET = 'most_liked'
type COMMUNITY_STATISTICS_WIDGET = 'community_statistics'

export type TypesThatCanBeAdded = HTML_WIDGET | TAG_CLOUD | BADGES_WIDGET | SOLVED_TOPICS_WIDGET | MOST_LIKED_WIDGET | COMMUNITY_STATISTICS_WIDGET

export type widgetsToAddSidebar = {
  type: HTML_WIDGET | TAG_CLOUD | BADGES_WIDGET | SOLVED_TOPICS_WIDGET | MOST_LIKED_WIDGET | COMMUNITY_STATISTICS_WIDGET,
  title: string,
  description: string
}

export type widgetsToAddMainContent = {
  type: HTML_WIDGET,
  title: string,
  description: string
}

export type widgetsToAddFullWidth = {
  type: HTML_WIDGET,
  title: string,
  description: string
}

interface Props {
  onClick: (type: TypesThatCanBeAdded) => void,
  widgetList: Array <widgetsToAddSidebar | widgetsToAddFullWidth | widgetsToAddMainContent>
}

export default ({ onClick, widgetList }: Props) => {
  return (
    <Dropdown
      className='sitewidth new-widget-dropdown-container'
      class='new-widget-dropdown-list'
      trigger={<div className='new-widget-dropdown-button'>
        <Icon
          icon='addWidget'
          color='#2B3346'
        />
      </div>}
    >
      <ul>
        {
          widgetList.map((widget) => (
            <li
              className={`new-widget-dropdown-item ${widget.type}`}
              onClick={
                () => onClick(widget.type)
              }>
              <div className='new-widget-dropdown-item-title'>{widget.title}</div>
              <div className='new-widget-dropdown-item-description'>{widget.description}</div>
            </li>
          ))
        }
      </ul>
    </Dropdown>
  )
}
